import Vue from 'vue';
import { createHelpers } from 'vuex-map-fields';
import router from '@/router/index';

import {
  HEALTH_REQUEST,
  HEALTH_SET_DEPENDENT_PERSON,
  HEALTH_SET_CARE_LEVEL,
  HEALTH_TOGGLE_CARE_LEVEL_MODAL,
} from '../actions/health';

import { CARELEVEL_REQUEST } from '@/store/actions/careLevelCalculator';
import { APPLICATION_REQUEST } from '@/store/actions/application';
import { CARESERVICE_REQUEST } from '@/store/actions/careService';

import {
  ROUTE_API_GET_CARE_LEVEL_DATA,
  ROUTE_API_GET_CARE_PROFILE_DATA,
} from '@/constants/apiRoutes';
import { AUTH_LOGOUT } from '@/store/actions/auth';

const { getHealthField, updateHealthField } = createHelpers({
  getterType: 'getHealthField',
  mutationType: 'updateHealthField',
});

const state = {
  healthDataLoaded: false,

  /**
   * Uuid des CareProfiles (personInNeedOfCare)
   */
  healthUuid: null,

  /**
   * Wer soll gepflegt werden?
   * 'me' => Ich selbst
   * 'other' => Eine andere Person
   */
  dependentPerson: null,

  /**
   * 0 = Hat Pflegegrad
   * 1 = Pflegegrad beantragt
   * 2 = Kein Pflegegrad
   */
  careLevelSituation: null,

  /**
   * Pflegegrad 1-5
   * Wichtig: Hier steht der Pflegegrad drin, egal ob
   * er bestätigt ist oder nur beantragt. Daher
   * immer noch "careLevelSituation" beachten!
   */
  careLevel: null,

  /**
   * Datum der Vergabe des Pflegegrades
   * Wichtig: Genau wie bei careLevel muss hier
   * immer noch "careLevelSituation" beachtet werden!
   */
  careLevelDate: null,

  /**
   * Öffnet das Pflegegrad Modal zum Anpassen
   * des Pflegegrades
   */
  showCareLevelModal: false,

  /**
   * Öffnet beim ersten Login eines Users ein Modal,
   * das zum PGR-Ergebnis führt
   */
  unregisteredUuid: null,
};

const getters = {
  getHealthField,
};

const mutations = {
  updateHealthField,

  [HEALTH_REQUEST]: (state, data) => {
    state = Object.assign(state, data);
  },

  [HEALTH_SET_DEPENDENT_PERSON]: (state, type) => {
    state.dependentPerson = type;
  },

  [HEALTH_TOGGLE_CARE_LEVEL_MODAL]: (state) => {
    state.showCareLevelModal = !state.showCareLevelModal;
  },

  [HEALTH_SET_CARE_LEVEL]: (state, data) => {
    state = Object.assign(state, data);
  },
};

const actions = {
  [HEALTH_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(ROUTE_API_GET_CARE_PROFILE_DATA)
        .then((response) => {
          const {
            personInNeedOfCareUuid,
            careProfile: { isProfileOwner, unregisteredUuid },
          } = response.data;

          let dependentPerson = null;

          if (isProfileOwner === 0) {
            dependentPerson = 'other';
          }

          if (isProfileOwner === 1) {
            dependentPerson = 'me';
          }

          commit(HEALTH_REQUEST, {
            healthUuid: personInNeedOfCareUuid,
            dependentPerson,
            unregisteredUuid,
          });

          Vue.axios
            .post(ROUTE_API_GET_CARE_LEVEL_DATA, { personInNeedOfCareUuid })
            .then((res) => {
              const {
                care_level_applied_for_at,
                care_level,
                care_level_approved_at,
                care_level_situation,
                unregisteredUuid,
                module_points_json,
                calculated_care_level,
                calculated_care_level_at,
                user_value,
                is_complete,
              } = res.data.careLevelWizard[0];

              let careLevelSituation = care_level_situation >= 0 ? care_level_situation : null;
              let careLevelDate = null;

              if (care_level_applied_for_at && careLevelSituation === 1) {
                careLevelDate = care_level_applied_for_at;
              }

              if (care_level_approved_at && careLevelSituation === 0) {
                careLevelDate = care_level_approved_at;
              }

              dispatch(CARELEVEL_REQUEST, {
                modulePoints: module_points_json ? JSON.parse(module_points_json) : null,
                calculatedCareLevelAt: calculated_care_level_at,
                calculatedCareLevel: calculated_care_level,
                currentWizardIsComplete: !!is_complete && !!user_value,
                currentWizardUserValue: user_value ? JSON.parse(user_value) : null,
              }).then(() => {
                dispatch(CARESERVICE_REQUEST)
                  .then(() => {
                    commit(HEALTH_REQUEST, {
                      careLevelSituation,
                      careLevel: care_level,
                      careLevelDate,
                      healthDataLoaded: true,
                      unregisteredUuid,
                    });

                    dispatch(APPLICATION_REQUEST);

                    resolve({
                      showIntro: isProfileOwner === null,
                    });
                  })
                  .catch(reject);
              });
            })
            .catch(reject);
        })
        .catch(() => {
          dispatch(AUTH_LOGOUT)
            .then(() => {
              router.push('404');
            })
            .catch(() => {
              router.push('404');
            });
        });
    });
  },

  [HEALTH_SET_DEPENDENT_PERSON]: ({ commit }, type) => {
    commit(HEALTH_SET_DEPENDENT_PERSON, type);
  },

  [HEALTH_SET_CARE_LEVEL]: ({ commit }, data) => {
    commit(HEALTH_SET_CARE_LEVEL, data);
  },

  [HEALTH_TOGGLE_CARE_LEVEL_MODAL]: ({ commit }) => {
    commit(HEALTH_TOGGLE_CARE_LEVEL_MODAL);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
